
import moment from "moment";


export function getCurrentDate(separator='-'){

    let newDate = new Date()
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${date<10?`0${date}`:`${date}`}${separator}${month<10?`0${month}`:`${month}`}${separator}${year}`
}

export function getCurrentTimestamp(format=''){
    return moment().format(format)
}


export const arraySearch = (array, keyword) => {
    const searchTerm = keyword.toLowerCase()
    return array.filter(value => {
        console.log(value.row.length)
        return value.row[0].answer.toLowerCase().match(new RegExp(searchTerm, 'g')) ||
            value.row[1].answer.toLowerCase().match(new RegExp(searchTerm, 'g')) ||
            (value.row.length > 2 ? value.row[2].answer.toLowerCase().match(new RegExp(searchTerm, 'g'))
            : '') ||
            (value.row.length > 3 ? value.row[3].answer.toLowerCase().match(new RegExp(searchTerm, 'g'))
                : '') ||
            (value.row.length > 4 ? value.row[4].answer.toLowerCase().match(new RegExp(searchTerm, 'g'))
                : '') ||
            (value.row.length > 5 ? value.row[5].answer.toLowerCase().match(new RegExp(searchTerm, 'g'))
                : '') ||
            (value.row.length > 6 ? value.row[6].answer.toLowerCase().match(new RegExp(searchTerm, 'g'))
                : '') ||
            (value.row.length > 7 ? value.row[7].answer.toLowerCase().match(new RegExp(searchTerm, 'g'))
                : '')
    })
}


